import React from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { navigate } from 'gatsby';
import { DefaultProfileIcon } from 'assets/svgs';
import { OnlineIndicator, Button } from 'components';

function Moderators({ moderators, variants, onlineUsers, sessionId, user }) {
  const handleAnalyticsClick = () => {
    navigate(`/analytics?sessionId=${sessionId}`);
  };

  return (
    <>
      <ModeratorsContainer
        key="moderators"
        variants={variants}
        initial="hidden"
        animate="visible"
        exit="hidden">
        <h3>Moderators</h3>
        {moderators
          .sort((a, b) =>
            a.company < b.company ? 1 : b.company < a.company ? -1 : 0
          )
          .filter(
            (moderator) => moderator.email !== 'ronan.fahey@astrazeneca.com'
          )
          .map((moderator) => (
            <Moderator key={moderator.id}>
              <ProfilePictureContainer>
                {moderator?.avatarUrl ? (
                  <ProfilePicture
                    src={moderator.avatarUrl}
                    alt={moderator.name}
                  />
                ) : (
                  <DefaultProfileIcon />
                )}
                <OnlineIndicatorContainer>
                  <OnlineIndicator
                    isOnline={onlineUsers?.some((u) => u.id === moderator.id)}
                    size="12px"
                  />
                </OnlineIndicatorContainer>
              </ProfilePictureContainer>
              <ModeratorInfo>
                <ModeratorName>{moderator.name}</ModeratorName>
                {moderator.company && (
                  <span>
                    {moderator.company}
                    {moderator.role && ', '}
                  </span>
                )}
                {moderator.role && <span>{moderator.role}</span>}
              </ModeratorInfo>
            </Moderator>
          ))}
      </ModeratorsContainer>
      {user &&
        user.isModerator?.includes(sessionId) &&
        user.email.includes('agencyx.ie') && (
          <AnalyticsButtonWrapper>
            <Button
              onClick={handleAnalyticsClick}
              backgroundColor="var(--blue)"
              textColor="#fff"
              style={{
                fontSize: '0.875rem',
                padding: '0.5em 1.5em'
              }}>
              View Analytics
            </Button>
          </AnalyticsButtonWrapper>
        )}
    </>
  );
}

const ModeratorsContainer = styled(motion.div)`
  border-top: 1px solid var(--light-grey);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 0;
  width: 100%;
  h3 {
    font-size: 1.25rem;
    font-weight: 600;
  }
`;

const Moderator = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`;

const ModeratorInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  font-weight: 400;
  gap: 0.063rem;

  span {
    color: var(--blue);
    font-size: 0.875rem;
    font-weight: 400;
  }
`;

const ModeratorName = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
`;

const ProfilePictureContainer = styled.div`
  background-color: var(--light-grey);
  border-radius: 50%;
  height: 2.875rem;
  overflow: visible;
  position: relative;
  width: 2.875rem;
`;

const ProfilePicture = styled(motion.img).attrs({
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
})`
  background: transparent;
  border-radius: 50%;
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const OnlineIndicatorContainer = styled.div`
  position: absolute;
  right: -2px;
  top: -2px;
  z-index: 10;
`;

const AnalyticsButtonWrapper = styled.div`
  border-top: 1px solid var(--light-grey);
  display: flex;
  justify-content: center;
  /* margin-top: 1rem; */
  padding-top: 1.5rem;
  width: 100%;

  @media (max-width: 1199px) {
    padding-bottom: 1.25rem;
  }
`;

export default Moderators;
